import Vue from 'vue';
import Router from 'vue-router';
import { Message } from 'element-ui';
import store from '../store';

// Router modules
import common from './modules/common';
import account from './modules/account';
import dashboard from './modules/dashboard';
import reports from './modules/reports';
import surveys from './modules/surveys';
import registration from './modules/registration';

Vue.use(Router);

const removedRoutes = process.env.VUE_APP_REMOVED_ROUTES
  ? process.env.VUE_APP_REMOVED_ROUTES.split(' ')
  : null;

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve) => {
      const timeout = (savedPosition ? 200 : 400);
      setTimeout(() => {
        if (savedPosition) {
          resolve(savedPosition);
        } else {
          window.scrollTo(0, 0);
          resolve({ x: 0, y: 0 });
        }
      }, timeout);
    });
  },
  base: process.env.BASE_URL,
  routes: [
    ...common,
    ...account,
    ...dashboard,
    ...reports,
    ...surveys,
    ...registration,
  ].filter((el) => (removedRoutes ? !removedRoutes.includes(el.name) : true)),
});

router.afterEach(() => {
  const mainScrollArea = document.getElementById('mainContents');
  if (mainScrollArea) mainScrollArea.scrollTop = 0;
});

router.beforeEach(async (to, from, next) => {
  if (!to.meta.roles) {
    next();
    return;
  }

  const storage = localStorage[process.env.VUE_APP_VUEX_KEY]
    ? JSON.parse(localStorage[process.env.VUE_APP_VUEX_KEY])
    : null;

  // console.log(to, from, storage);

  if (store.getters['common/shouldRefreshUser']) {
    // console.log('refresh');
    if (process.env.VUE_APP_SERVICE === 'gcg_platform') {
      try {
        await store.dispatch('user/fetchCurrentUser');
      } catch (err) {
        console.log('router dispatch current user error', err);
      }
    }
  } else {
    // console.log('no refresh');
  }

  const isLoggedIn = storage && storage.user && storage.user.user && storage.user.user.uuid;
  // Route restriction
  if (isLoggedIn && (to.meta.roles || to.meta.minSession)) {
    // roles restriction
    if (to.meta.roles) {
      // console.log('is role restricted');
      let role = null;
      let isNonAc = null;
      if (storage && storage.user && storage.user.user && storage.user.user.role_type) {
        role = storage.user.user.role_type;
        isNonAc = !storage.user.profile.is_ac;
      }

      if (role === 'NO_ROLE') {
        next({ name: 'error' });
        return;
      }

      if (!to.meta.roles.includes(role)) {
        if (role === 'coach' && to.name === 'dashboard') {
          next({ name: 'calendar' });
        }
      }

      if (role === 'coach' && isNonAc && to.meta.navMenuOptions.hideForNonAc) {
        next({ name: '404' });
      }
    }

    if (to.meta.minSession) { // Session restriction
      // console.log('is session restricted');
      const session = storage.processStatus.process.session || 0;
      // console.log('current session: ', session);
      if (session < to.meta.minSession) {
        Message.warning('You do not have access to this page yet');
        next({ name: 'dashboard' });
        return;
      }
    }

    next();
  }

  next();
});

export default router;
